/*
 * File: core.ts
 * File Created: 2024-02-19 04:40:07
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-27 10:55:28
 * Modified By: Val Liu
 * -----
 */

import { ObjectHelper } from "@root/core/utilities/object-helper";
import { IQuickUnit, QuickHelper } from "@root/core/utilities/quick-helper";

export const WHERE_RECYCLE_FALSE = { where: { recycled: false } };

export function PARAMS_WHERE(this: IQuickUnit) {
    // return WHERE_RECYCLE_FALSE;
    return undefined;
}

export function PARAMS_INCLUDE(this: IQuickUnit) {
    return ObjectHelper.deepMerge(
        QuickHelper.includeParents(this),
        QuickHelper.includeFiles(this),
    );
}
